<template>
    <v-dialog v-model="dialog" max-width="500px" persistent >
        <v-card>
            <v-card-title class="pb-1">
                <div class="title">Agregar Síntoma</div>
                <v-spacer></v-spacer>
                <v-switch class="switch-center" v-model="details" :label="isMobile ? 'detalles' : 'Agregar detalles'"/>
            </v-card-title>
            <v-card-subtitle>
                <div class="subtitle">{{symptom.title}}</div>
            </v-card-subtitle>
                <v-card-text class="py-1">
                  <v-slide-y-transition>

                    <v-row v-show="details" align="center" justify="center">

                      <v-col cols="6" sm="4">
                        <v-text-field
                            @focus="$event.target.select()"
                            outlined
                            dense
                            hide-details
                            label="Duración"
                            v-model="symptom.duration"
                            type="number"/>
                      </v-col>
                      <v-col cols="6" sm="4" >
                        <v-select
                            dense
                            outlined
                            hide-details
                            label="Unidad"
                            v-model="symptom.duration_unit"
                            :items="durationUnits"/>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-btn-toggle
                            color="primary"
                            dense
                            mandatory
                            v-model="symptom.eye"
                            v-if="userIsOphthalmologist">
                          <v-btn text  value="right" >
                            OD
                          </v-btn>
                          <v-btn text  value="left" >
                            OI
                          </v-btn>
                          <v-btn text  value="both" >
                            ODI
                          </v-btn>
                        </v-btn-toggle>
                      </v-col>
                    </v-row>
                  </v-slide-y-transition>

                </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="default" @click="hide">Cancelar</v-btn>
                <v-btn color="primary" :disabled="!valid" @click="attach" :loading="loading">Agregar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>
<script>
    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations, mapState} from 'vuex'

    import {userProvides, OPHTHALMOLOGY} from '@/utils/Specialist'

    export default{
        props: {
            eventId: {
                type: Number,
                required: true
            }
        },
        data(){
            return {
                dialog: false,
                loading: false,
                details: true,
                symptom: {
                    title: '',
                    duration: 0,
                    duration_unit: ''
                },
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            async attach(){

                var vm = this
                vm.loading = true
                let payload = vm.details ? vm.symptom : {symptom_id: vm.symptom.symptom_id}
                payload.schedule_event_id = vm.eventId

                const response = await ApiUtils.makePost(
                    `providers/${vm.currentProvider.id}/symptom/attach`,
                    payload
                )
                vm.loading = false

                if (response.ok) {
                    const json = await response.json()
                    const attachedItem = json.result.symptom
                    vm.$emit('attach', attachedItem)
                    vm.hide()
                    vm.reset()
                    return
                }

                const json = await response.json()
                vm.showSnackBar(json.message || 'Ha ocurrido un error intentando agregar medicamento')


            },
            reset(){
                var vm = this
                vm.symptom = {
                    title: '',
                    duration: 1,
                    duration_unit: 'day'
                }
            },
            show(symptom){

                this.symptom = symptom
                this.dialog = true
            },
            hide(){
                this.dialog = false
            }
        },
        computed:{
                ...mapState(['currentProvider']),
            userIsOphthalmologist(){
                return userProvides(OPHTHALMOLOGY)
            },
            valid(){
                var vm = this
                return vm.details && (vm.symptom &&
                    vm.symptom.duration &&
                    vm.symptom.duration_unit) || !vm.details
            },
            durationUnits(){
                return [
                    {
                        text: 'año(s)',
                        value: 'year'
                    },
                    {
                        text: 'mes(es)',
                        value: 'month'
                    },
                    {
                        text: 'semana(s)',
                        value: 'week'
                    },
                    {
                        text: 'día(s)',
                        value: 'day'
                    },
                    {
                        text: 'hora(s)',
                        value: 'hour'
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .switch-center {
        display: flex;
        justify-content: center;
    }
</style>
